import type { IconData } from '@stacksjs/iconify-core'

export const spiralShape: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M21.54 26.509c-.686-.582.182-2.17 1.781-1.82c1.537.184 3.03 2.728 1.645 5.318c-1.166 2.58-5.395 4.23-8.77 1.958c-3.423-2.002-4.845-7.966-1.508-12.453c3.017-4.568 10.605-6.298 15.758-2.097c5.307 3.812 6.66 13.216 1.372 19.588c-4.872 6.568-15.813 8.356-22.746 2.237C1.886 33.611.59 20.781 7.836 12.515C14.56 3.948 28.862 2.1 37.57 10.14c9.072 7.448 10.3 23.697 1.1 33.86\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default spiralShape
